// src/pages/SignupSelect.js

import React from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { SecondaryButton } from "../../component/Button";
import Logo from "../../component/Logo";

function SignupSelect() {
  const navigate = useNavigate();

  return (
    <Container>
      <Logo>Speech4All</Logo>
      <h2>회원가입 유형을 선택해주세요</h2>
      <ButtonGroup>
        <SecondaryButton size="large" onClick={() => navigate("/signup/individual")}>
          개인 회원가입
        </SecondaryButton>
        <SecondaryButton size="large" onClick={() => navigate("/signup/organization")}>
          기관 회원가입
        </SecondaryButton>
      </ButtonGroup>
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 30px;
  justify-content: center;
  height: 100vh;
`;

const ButtonGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

export default SignupSelect;
